export const API_OPERATIONS = {
  GENERATE_REPORT_PDF: 'reports.generatePdf',
  RESEND_INVITATION: 'user.resendInvitation',
  INVITE_ACCEPTANCE_CONTEXT: 'user.getInviteContext',
  ONBOARDING_CONTEXT: 'user.getOnboardingContext',
  REDEEM_USER_INVITE: 'user.redeemInvite',
  DELETE_INVITATION: 'user.deleteInvitation',
  COMPLETE_USER_ONBOARDING: 'user.completeOnboarding',
  UPDATE_USER_PROFILE: 'user.updateProfile',
  UPDATE_USER_PERMISSIONS: 'user.updatePermissions',
  SCHEDULE_DASHBOARD: 'search.schedules',
  SEND_ACCESS_KEY_MAIL: 'attendance.sendAccessKeyMail',

  EMAIL_PIN_SEND_PIN: 'emailPin.sendPin',
  EMAIL_PIN_CODE_ACCESS: 'emailPin.codeAccess',
  MARKING_PORTAL_CHECKIN: 'markingPortal.checkIn',

  MAIL_VALIDATION_DT: 'timeTracker.mailValidation',
  SEND_CODE_ACCESS_DT: 'timeTracker.codeAccess',
  CORPORATION_LIST_DT: 'timeTracker.corporationList',
  ORG_BY_CORPORATION_DT: 'timeTracker.orgByCorporation',
  FIND_USERS_DT: 'timeTracker.findUsers',
  SHIFT_REPORT_DT: 'timeTracker.shiftReport',
  HOLIDAYS_REPORT_DT: 'timeTracker.sundaysHoliday',
  DAILY_REPORT_DT: 'timeTracker.report',
  MODIFICATIONS_REPORT_DT: 'timeTracker.shiftAuditLogs',
  INCIDENTS_REPORT_DT: 'timeTracker.technicalDifficult',
  GET_ATTENDANCE_EVENT: 'attendance.getEvent',
  NEW_ATTENDANCE_EVENT: 'attendance.newEvent',
  PREPARE_ATTENDANCE_SESSIONS: 'attendance.prepareSessions',
  CANCEL_ATTENDANCE_EVENT: 'attendance.cancelEvent',
  FISCALIZATION_REPORT: 'attendance.sendFiscMail',
  ATTENDANCE_DASHBOARD_QUERY: 'search.attendanceQuery',

  SCHEDULES_COMPLIANCE: 'search.schedulesCompliance',
  COMPLIANCE_HISTOGRAM: 'search.complianceHistogram',
  TABLE_DASHBOARD: 'search.table',
  EVENTS_COUNTER: 'search.eventsCounter',
  SCHEDULES_COMPLETION: 'search.schedulesCompletion',
  HISTOGRAM_BY_EVENTS: 'search.eventsHistogram',
  NUMBER_METRICS_DASHBOARD: 'search.numberMetrics',
  EXECUTIONS_RECORDS_DASHBOARD: 'search.executionRecords',
  EVENT_COMPONENT_COUNTER: 'search.eventComponentCounter',
  POSITIONS_DASHBOARD: 'search.positions',
  EVENTS_BY_POSITIONS: 'search.eventsByPosition',
  EXECUTIONS_DASHBOARD_EXPORT: 'search.executionsExport',
  EXECUTIONS_HISTORY_DASHBOARD: 'search.executionsHistoryDashboard',

  CREATE_AGREEMENT_SHIFT_CHANGE: 'documentRequest.createAgreementShiftChange',
  CREATE_AGREEMENT_WORK_JOURNEY_CHANGE: 'documentRequest.createAgreementWorkJourneyChange',
  CREATE_AGREEMENT_OVERTIME: 'documentRequest.createAgreementOvertime',
  CREATE_AGREEMENT_OVERTIME_COMPENSATION: 'documentRequest.createAgreementOvertimeCompensation',
  CREATE_NOTIFICATION: 'documentRequest.createNotification',
  CREATE_CONTRACT_APPENDIX: 'documentRequest.createContractAppendix',
  SIGN_DOCUMENT_REQUEST: 'documentRequest.sign',
  REJECT_DOCUMENT_REQUEST: 'documentRequest.reject',

  CANCEL_EXECUTION: 'executionState.cancel',
  REPORT_EXECUTION_STALL: 'executionState.reportStall',
  END_EXECUTION_STALL: 'executionState.endStall',
  SUPERVISOR_CLOSE_EXECUTION: 'executionState.closeOnBehalf',

  CHANGE_PASSWORD: 'auth.changePassword',
  SEND_PASSWORD_RESET_EMAIL: 'auth.sendPasswordResetEmail',
  SIGN_UP: 'auth.signUp',
  SIGN_UP_UPDATE: 'auth.signUpUpdate',
  CREATE_API_TOKEN: 'auth.createApiToken',
  CREATE_REST_API_V2_CREDENTIAL: 'restApiV2Credential.create',
  CREATE_REST_API_V2_EVENT_SUBSCRIPTION: 'restApiV2Subscription.create',
  CHANGE_EMAIL: 'user.changeEmail',
  CONFIRM_EMAIL_CHANGE: 'user.confirmEmailChange',

  GENERIC_FIND: 'generic.elasticFind',
  QUERY: 'generic.query',

  USER_INVITATION: 'user.sendInvitation',
  UPDATE_USER: 'user.update',
  GET_USERS_WITH_JOURNEY: 'user.getWithJourney',
  GET_USER_INFO: 'user.getAllInfo',

  UPDATE_WORK_JOURNEY: 'workJourney.update',
  UPDATE_WORK_JOURNEY_MEMBERS: 'workJourney.updateMembers',
  LIST_REPLACEMENT_CANDIDATES: 'workJourney.listCandidates',
  LIST_WORK_JOURNEY_MANAGEMENT_JOURNEYS: 'workJourney.listJourneys',
  LIST_WORK_JOURNEY_MANAGEMENT_CALENDAR: 'workJourney.listCalendar',
  LIST_WORK_JOURNEY_MANAGEMENT_ATTENTION: 'workJourney.listAttention',
  LIST_WORK_JOURNEY_MANAGEMENT_MONTH_MATRIX: 'workJourney.listMonthMatrix',
  LIST_WORK_JOURNEY_MANAGEMENT_DAY_REPORT: 'workJourney.listDayReport',
  LIST_WORK_JOURNEY_MANAGEMENT_DAY_REPORT_DETAIL: 'workJourney.listDayReportDetail',
  IGNORE_REJECTED_SHIFT_CHANGE: 'workJourney.ignoreRejected',
  RESEND_REJECTED_SHIFT_CHANGE: 'workJourney.resendRejected',
  PLAN_MONTHLY_JOURNEY: 'workJourney.planMonthly',
  CREATE_MATRIX_ATTENDANCE: 'workJourney.createMatrixAttendance',

  CREATE_TOTEM: 'totem.create',
  REVOKE_TOTEM: 'totem.revoke',

  UPSERT_ORGANIZATION_TRIGGER: 'organizationTrigger.upsert',
  DELETE_ORGANIZATION_TRIGGER: 'organizationTrigger.delete',
  UPSERT_ORGANIZATION_FORM: 'organizationForm.upsert',
  DELETE_ORGANIZATION_FORM: 'organizationForm.delete',
  CREATE_OPTION_LIST: 'optionList.create',
  UPDATE_OPTION_LIST: 'optionList.update',
  ARCHIVE_OPTION_LIST: 'optionList.archive',

  COST_CENTERS_LIST: 'costCenters.list',
  COST_CENTERS_GET: 'costCenters.get',
  COST_CENTERS_CREATE: 'costCenters.create',
  COST_CENTERS_UPDATE: 'costCenters.update',
  COST_CENTERS_SET_ACTIVE: 'costCenters.setActive',
  COST_CENTERS_INCONSISTENCIES: 'costCenters.inconsistencies',
  COST_CENTERS_ASSIGN_USER: 'costCenters.assignUser',
  COST_CENTERS_USER_HISTORY: 'costCenters.userHistory',

  ORGANIZATION_DELETE_PREVIEW: 'organization.deletePreview',
  ORGANIZATION_DELETE: 'organization.delete',
  DIVISION_SUMMARIES: 'organizationDivision.summaries',
  WORKER_SCORE_RANKING: 'workerScore.ranking',
  WORKER_SCORE_NOTES: 'workerScore.notes',
  WORKER_SCORE_NOTE: 'workerScore.note',
  WORKER_SCORE_EXTRACT: 'workerScore.extract',

  DELETE_SCHEDULE: 'schedules.delete',
  SAVE_SCHEDULE: 'schedules.save',

  EMERGENCY_COMMAND: 'emergencies.command',

  PLATFORM_ACCOUNT_LIST: 'platform.accountList',
  PLATFORM_ACCOUNT_GET: 'platform.accountGet',
  PLATFORM_ACCOUNT_AUDIT_LOG: 'platform.accountAuditLog',
  PLATFORM_EXTEND_TRIAL: 'platform.extendTrial',
  PLATFORM_CHANGE_PLAN: 'platform.changePlan',
  PLATFORM_MARK_PAID: 'platform.markPaid',
  PLATFORM_SUSPEND: 'platform.suspend',
  PLATFORM_REACTIVATE: 'platform.reactivate',
  PLATFORM_CANCEL: 'platform.cancel',
  PLATFORM_LINK_ORGANIZATION: 'platform.linkOrganizationToCorporation',
  PLATFORM_CORPORATION_UPSERT: 'platform.corporationUpsert',
} as const;

export type ApiOperation = (typeof API_OPERATIONS)[keyof typeof API_OPERATIONS];
